// Integer hashing avoids the precision bands produced by sin(large UVs).
// The seed changes the grain rather than translating a screen-space lattice.
export const FILM_GRAIN_GLSL = /* glsl */`
float sensorNoise(vec2 pixel, float seed) {
  uvec2 p = uvec2(floor(pixel));
  uint h = p.x * 1597334677u ^ p.y * 3812015801u ^ uint(seed) * 2798796415u;
  h = (h ^ (h >> 16u)) * 2246822519u;
  h = (h ^ (h >> 13u)) * 3266489917u;
  h ^= h >> 16u;
  return float(h >> 8u) * (1.0 / 16777216.0);
}
`;
